import React from 'react'
import { Link } from 'react-router-dom'
import about from '../img/about.jpg'

const Aboutsection = () => {
    return (
        <>
            <div className='aboutsect'>

                <div className="aboutsect2">
                    <div className="image-container">
                        <img src={about} alt="About" />
                    </div>
                </div>


                <div className='aboutsect2'>
                    <h1>Welcome to Dr. Jitendra Prasad <span>Dermetology Center </span></h1>
                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>

                    <Link to='/'> <button className="read-more-btn">Read More</button></Link>


                </div>


            </div>


        </>
    )
}

export default Aboutsection
